import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

// components
import ButtonOpenTour from 'productTours/components/ButtonOpenTour';

// context
import { useUser } from 'shared/hooks/api/user';

// hooks
import useViewportHeight from 'shared/hooks/useViewportHeight';

// styles
import * as Container from 'sidePanel/styles/DemoMessage.style';
import * as Text from 'theme/components/Text.style';
import { Link } from '@mui/material';

export default function DemoMessage(): React.ReactElement {
  const { t } = useTranslation('sidePanel');
  const { data: user } = useUser();

  useViewportHeight();

  if (!user?.is_demo) return <></>;

  return (
    <Container.DemoMessage>
      <Text.P2Semibold>
        <Trans
          i18nKey="demoBanner"
          t={t}
          components={[
            <Link
              key="0"
              href="https://meetings.hubspot.com/justin-lessard-wajcer"
              underline="none"
              target="_blank"
            />,
          ]}
          ns="pageLayout"
        />
      </Text.P2Semibold>
      <ButtonOpenTour />
    </Container.DemoMessage>
  );
}
